import { GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { baseURL } from "../../../../config/api";
import { CustomDataGrid } from "../../../../components/CustomDataGrid";



export const TireFitment = () => {
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [totalLength, setTotalLength] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const columns: GridColDef[] = [
        {
            field: "tireFitmentID",
            headerName: "#",
            flex: 1,
            editable: false,
            sortable: false,
            renderCell: (params) => {
                return (
                    <Link to="/admin/settings/tire-fitment/edit-tire-fitment" state={params?.id} className="underline text-[#0000ff]">
                        {params?.value}
                    </Link>
                );
            },
        },
        {
            field: "height",
            headerName: "Height",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "sectionWidth",
            headerName: "Section Width",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "metricWidth",
            headerName: "Metric Width",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "aspectRatio",
            headerName: "Aspect Ratio",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "diameter",
            headerName: "Diameter",
            flex: 1,
            editable: false,
            sortable: false,
        },
        {
            field: "isCommercial",
            headerName: "isCommercial",
            flex: 1,
            editable: false,
            sortable: false,
        },
    ];




    useEffect(() => {
        emptySearchApiCall(paginationModel);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const emptySearchApiCall = (newPaginationModel: any) => {
        setLoading(true);
        fetch(`${baseURL}tireFitments/GetTireFitmentsPaging/${newPaginationModel?.page},${newPaginationModel?.pageSize}`)
            .then((res) => res.json())
            .then((data) => {
                const result = data?.tireFitments?.map((item: any) => {
                    return {
                        ...item,
                        id: item?.tireFitmentID,
                        isCommercial: item?.isCommercial ? "Yes" : "No"
                    };
                })

                setSearchTableData(result);
                setTotalLength(data?.count);
                setLoading(false);
            })
            .catch(error => {
                setSearchTableData([]);
                setTotalLength(0);
                setLoading(false);
                console.error(error);
            });
    }


    return (
        <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
            <div className="w-full bg-white p-4 rounded-md">
                <div className="w-full">
                    <div className="flex items-center justify-end py-2">
                        <div className="flex items-center gap-2.5">
                            <button className={`px-[8px] py-[6px] bg-primary rounded-lg border text-white flex items-center gap-1.5`}
                                onClick={() => navigate("/admin/settings/tire-fitment/add-tire-fitment")}
                            >
                                <span className="material-symbols-outlined text-[25px] font-light">
                                    add
                                </span>
                                <span className="text-xs font-medium">Tire Fitment</span>
                            </button>

                        </div>
                    </div>
                    <div className={`w-full border border-[#E4E7EC] rounded-[16px]`}>
                        <div className={`flex justify-between items-center p-4 border-b border-[#E4E7EC]`}>
                            <div className="flex items-center gap-1.5">

                                <h2 className={`text-lg font-semibold text-[#1D2939]`}>Tire Fitment</h2>
                            </div>

                        </div>

                        <CustomDataGrid
                            filteredRows={searchTableData}
                            columns={columns?.map(col => ({
                                ...col,
                                headerClassName: "bg-[#F9FAFB]",
                            }))}
                            loading={loading}
                            totalLength={totalLength}
                            paginationModel={paginationModel}
                            setPaginationModel={setPaginationModel}
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}